import {connect} from "react-redux";
import FSEs from "./Fse";
import {bindActionCreators} from "redux";
import {fseDetailsPJP, getFse} from "../../../../service/FasttagToll/action";
import {tollById} from "../../../../service/FasttagToll/action";
const mapStateToProps = (state) => ({
    PJPReviewDetails:state.FasttagToll.PJPReviewDetails,
    tollView:state.FasttagToll.tollView,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            fseDetailsPJP,
            tollById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(FSEs);
